import styled from "styled-components";

const Container = styled.div<{ backgroundColor: string }>`
  display: grid;
  position: relative;
  grid-template-columns: 1fr 1fr;
  gap: 160px;
  padding: 140px 70px;

  width: calc(100% + 140px);
  margin-left: -70px;
  min-height: 400px;
  align-items: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor === "white" ? "#f9f9f9" : backgroundColor};

  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
    gap: 30px;
    width: 100vw;
    margin-left: -70px;
    padding: 50px;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-left: -20px;
    padding: 33px 16px;
    gap: 0px;
  }
`;

const Wrapper = styled.div``;

const S = {
  Container,
  Wrapper,
};

export default S;
